// extracted by mini-css-extract-plugin
export var centerText = "_e7-8";
export var container = "_e7-0";
export var doughnutContainer = "_e7-7";
export var legend = "_e7-a";
export var legendItemColorDisplay = "_e7-b";
export var legendItemLabel = "_e7-d";
export var legendItemValue = "_e7-c";
export var lg = "_e7-5";
export var maxWidth = "_e7-9";
export var md = "_e7-4";
export var responsive = "_e7-6";
export var sm = "_e7-3";
export var xs = "_e7-2";
export var xxs = "_e7-1";